import { Button } from "@mantine/core";
import {
  IconArrowsDiagonalMinimize2,
  IconArrowsMaximize,
} from "@tabler/icons-react";
import React from "react";
import { useProfileStore } from "../../store/profileStore";

const MinimizeButton: React.FC = () => {
  const { sidebarCollapsed, setSidebarCollapsed } = useProfileStore();
  return (
    <div>
      <Button
        m="sm"
        size="xs"
        color={sidebarCollapsed ? "blue" : "gray"}
        leftSection={
          sidebarCollapsed ? (
            <IconArrowsMaximize />
          ) : (
            <IconArrowsDiagonalMinimize2 />
          )
        }
        variant={"transparent"}
        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
        style={{
          transition: "all 0.3s ease-in-out",
          transform: sidebarCollapsed ? "scale(1.1)" : "scale(1)",
        }}
      >
        {sidebarCollapsed ? "Show Sidebar" : "Hide Sidebar"}
      </Button>
    </div>
  );
};

export default MinimizeButton;
